var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"rc-icon",attrs:{"src":_vm.icon,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }